import { DAPI_URL } from "@env";

export default {
  api: {
    domain: DAPI_URL,
  },
};
